import React from 'react';
import {
  getAdditionalsAndTotal,
  getPriceForDescription,
} from './AdditionalOrderSummary.helper';
import styles from './AdditionalOrderSummary.module.scss';
import { ProductChoice } from '../../utils/Data/customizeConnector';
import { useGTBCheckoutContext } from '../../pages/GTBCustomize/ContextProviders/GTBContext';

const AdditionalOrderSummary = () => {
  const { choices } = useGTBCheckoutContext();
  const { additionals, total } = getAdditionalsAndTotal(choices);
  const totalLabel = getPriceForDescription(total);

  if (!additionals || additionals?.length <= 0) return null;

  return (
    <div className={styles.additionalSummaryContainer}>
      <div className={styles.additionalSummary}>
        <div className={styles.additionalSummaryTitle}>
          <h4>Additional Choices Order Summary</h4>
        </div>
        <div role="list" className={styles.additionalSummaryOrderContainer}>
          {additionals.map((additional: ProductChoice, index: number) => (
            <div
              key={`${additional.questionId}-${additional.optionId}`}
              data-testid={`additional-option-${index}`}
              role="listitem"
              className={styles.additionalSummaryOrder}
            >
              <div>
                <p data-testid={`additional-option-${index}-name`}>{additional.name}</p>
                <p
                  data-testid={`additional-option-${index}-quantity`}
                  className={styles.quantity}
                >
                  x
                  {additional.additionalQuantity}
                </p>
              </div>
              <p
                data-testid={`additional-option-${index}-price`}
                className={styles.subtotal}
              >
                {getPriceForDescription(
                  additional.additionalItemCost * additional.additionalQuantity,
                )}
              </p>
            </div>
          ))}
        </div>
        <p className={styles.taxHint}>
          Please note that you will be charged sales tax, if applicable.
        </p>
        <div className={styles.totalContainer}>
          <p>Total</p>
          <p>
            $
            {`${totalLabel} `}
            USD
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdditionalOrderSummary;
